var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card-layer" }, [
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-between align-items-center",
            staticStyle: { "padding-right": "38px" }
          },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("h4", { staticClass: "mb-0 mr-2" }, [
                  _vm._v("Layer Access Application")
                ]),
                _vm._v(" "),
                _c("jTooltipHint", {
                  attrs: { description: "Access the page using password" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("j-toggle", {
              staticStyle: { height: "20px" },
              model: {
                value: _vm.setupApplication.is_use_password,
                callback: function($$v) {
                  _vm.$set(_vm.setupApplication, "is_use_password", $$v)
                },
                expression: "setupApplication.is_use_password"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.setupApplication.is_use_password
          ? _c(
              "div",
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "session-access" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center",
                                staticStyle: { "margin-bottom": "5px" }
                              },
                              [
                                _c("label", { staticClass: "mb-0 mr-2" }, [
                                  _vm._v(" Standby Session Access ")
                                ]),
                                _vm._v(" "),
                                _c("jTooltipHint", {
                                  attrs: {
                                    description:
                                      "Session or duration for tolerance no one accesses the application, after that the user must request OTP re-verification"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.standbySessionAccess,
                                placeholder: "Select..."
                              },
                              model: {
                                value: _vm.setupApplication.standby_session,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.setupApplication,
                                    "standby_session",
                                    $$v
                                  )
                                },
                                expression: "setupApplication.standby_session"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue mt-3",
                        on: { click: _vm.submitApplication }
                      },
                      [_vm._v("\n          Save\n        ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-layer" }, [
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-between align-items-center",
            staticStyle: { "padding-right": "38px" }
          },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("h4", { staticClass: "mb-0 mr-2" }, [
                  _vm._v("Layer Access Pages")
                ]),
                _vm._v(" "),
                _c("jTooltipHint", {
                  attrs: { description: "Access the page using password" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("j-toggle", {
              staticStyle: { height: "20px" },
              model: {
                value: _vm.useSecurityPage,
                callback: function($$v) {
                  _vm.useSecurityPage = $$v
                },
                expression: "useSecurityPage"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.useSecurityPage
          ? _c("div", [
              _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c("jPagesList", {
                    attrs: { "list-pages": _vm.listPages },
                    on: { "open-setting": _vm.openModalSecurityPage }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalSecurityPage",
          staticClass: "mod-form modal-security-pages",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            [
              _vm.isOpenPopup
                ? _c("jPopupSecurityPage", {
                    attrs: {
                      "list-function": _vm.listFunction,
                      "selected-pages": _vm.selectedPages
                    },
                    on: { "close-modal": _vm.closeModalEditField }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("j-progress", {
        ref: "progressMappingPage",
        attrs: {
          "data-kirim": _vm.data_selected,
          "url-api": _vm.url_mapping_page,
          headers: _vm.headers
        },
        on: { finish: _vm.finishActionPage }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [
      _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("Information")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "If you implement security on layer access application, users will be required to enter their own password before accessing the application."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45d5b2c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d5b2c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/tab/jAccessApplicationTabSecurity.vue
// module id = null
// module chunks = 